import { render } from "./adminFeed.vue?vue&type=template&id=60573355&scoped=true"
import script from "./adminFeed.vue?vue&type=script&lang=js"
export * from "./adminFeed.vue?vue&type=script&lang=js"

import "./adminFeed.vue?vue&type=style&index=0&id=60573355&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60573355"]])

export default __exports__